import { createEpicMiddleware } from 'redux-observable';
import { ReportState } from '@sas-dvr/internal-va-react-core/store/rootReducer';
import { createStore } from '@sas-dvr/internal-va-react-core/store/createStore';
import { BirdEpicDependencies, rootEpic } from '../epics';
import { AnyAction } from 'redux';

export const createStoreWithBirdMiddleware = () => {
  const dependencies = new BirdEpicDependencies();
  const epicMiddleware = createEpicMiddleware<
    AnyAction,
    AnyAction,
    ReportState,
    BirdEpicDependencies
  >({
    dependencies,
  });
  const store = createStore(epicMiddleware);
  epicMiddleware.run(rootEpic);

  return store;
};
